import actionTypes from "./_actions";
import * as utils from "common/utils";

const INITIAL_STATE = [];

function reducer(state = INITIAL_STATE, action) {
    let offlineFarms = [...state];

    switch (action.type) {
        case actionTypes.IRRIGATOR_SUBMIT: {
            const offlineFarm = utils.getOfflineFarm(offlineFarms, action.payload.farmId);
            if (!offlineFarm) return state;
            const offlineBudget = utils.getOfflineBudget(offlineFarm, action.payload.budgetId);
            if (!offlineBudget) return state;
            if (!offlineBudget.budget.irrigators) offlineBudget.budget.irrigators = [];
            utils.merge(action.payload.irrigator, offlineBudget.budget.irrigators);
            offlineBudget.budget.irrigators = offlineBudget.budget.irrigators.map((irr) => {
                const irrigator = action.payload.irrigators.find((i) => i.id === irr.id);
                if (irrigator) {
                    const allBlockIds = offlineBudget.budget.blocks.map((b) => b.id);
                    return {
                        ...irr,
                        nonDrawnArea: irrigator.nonDrawnArea ? irrigator.nonDrawnArea.filter((nda) => allBlockIds.includes(nda.blockId)) : undefined,
                    };
                }
                return irr;
            });
            offlineBudget.budget.features = action.payload.features;
            offlineBudget.isDirty = true;
            return offlineFarms;
        }
        case actionTypes.IRRIGATOR_DELETE: {
            const offlineFarm1 = utils.getOfflineFarm(offlineFarms, action.payload.farmId);
            if (!offlineFarm1) return state;
            const offlineBudget1 = utils.getOfflineBudget(offlineFarm1, action.payload.budgetId);
            if (!offlineBudget1) return state;
            const irrigator = offlineBudget1.budget.irrigators.find((i) => i.id === action.payload.irrigator.id);
            if (irrigator) {
                offlineBudget1.budget.irrigators = offlineBudget1.budget.irrigators.filter((irr) => irr.id !== irrigator.id);
                offlineBudget1.budget.features = offlineBudget1.budget.features && offlineBudget1.budget.features.filter((f) => !f.properties.irrigatorId || f.properties.irrigatorId !== irrigator.id);
                offlineBudget1.isDirty = true;
            }
            return offlineFarms;
        }
        default:
            return state;
    }
}

export default reducer;
